import { createContext } from 'react';

const StoreContext = createContext({
  credencials: null,
  setCredencials: () => { },
  openModal: false,
  setOpenModal: () => { },
  modalUpgradePlan: false,
  setModalUpgradePlan: () => { },
  modalCashierSelect: false,
  setModalCashierSelect: () => { },
  modalCashierOpen: { open: false, cashierId: null },
  setModalCashierOpen: () => { },
  searchState: {},
  setSearchState: () => { },
  chatbotOpen: false,
  setChatbotOpen: () => { },
  chatbotSpecialist: 'general',
  setChatbotSpecialist: () => { },
  chatbotInitialPrompt: '',
  setChatbotInitialPrompt: () => { },
  openChatbotWithPrompt: () => { },
  chatbotUnreadCount: 0,
  setChatbotUnreadCount: () => { },
});

export default StoreContext;
